import axios from "./axiosInstance";

export const fetchProductPicks = () => axios.get("/api/provider-dashboard/product-picks");
export const saveProductPicks = (productIds) =>
  axios.put("/api/provider-dashboard/product-picks", { productIds });

// 대시보드
export const fetchDashboard = () =>
  axios.get("/api/provider-dashboard/dashboard");

// 예약 관리
export const fetchProviderSchedules = (params = {}) =>
  axios.get("/api/provider-dashboard/schedules", {
    params: Object.assign({}, params, { _cache: Date.now() }),
  });

export const confirmSchedule = (id) =>
  axios.patch(`/api/provider-dashboard/schedules/${id}/confirm`);

export const fetchProviderAvailableSlots = (date) =>
  axios.get("/api/provider-dashboard/schedules/available-slots", {
    params: { date },
  });

export const createOfflineReservation = (data) =>
  axios.post("/api/provider-dashboard/schedules/offline", data);

export const cancelOfflineReservation = (id) =>
  axios.patch(`/api/provider-dashboard/schedules/${id}/offline-cancel`);

export const requestScheduleReschedule = (id, data) =>
  axios.patch(
    `/api/provider-dashboard/schedules/${id}/reschedule-request`,
    data
  );

export const markVisited = (id) =>
  axios.patch(`/api/provider-dashboard/schedules/${id}/visited`);

export const markNoshow = (id) =>
  axios.patch(`/api/provider-dashboard/schedules/${id}/noshow`);

export const updateRingPickupExpectedDate = (id, ringPickupExpectedDate) =>
  axios.patch(`/api/provider-dashboard/schedules/${id}/ring-pickup-date`, {
    ringPickupExpectedDate,
  });

export const updateProviderMemo = (id, data) =>
  axios.put(`/api/provider-dashboard/schedules/${id}/memo`, data);

// 예약 설정
export const fetchBookingSettings = () =>
  axios.get("/api/provider-dashboard/booking-settings");

export const updateBookingSettings = (data) =>
  axios.put("/api/provider-dashboard/booking-settings", data);

// 견적 관리
export const fetchProviderEstimates = (params) =>
  axios.get("/api/provider-dashboard/estimates", { params });

export const fetchProviderEstimateDetail = (id) =>
  axios.get(`/api/provider-dashboard/estimates/${id}`);

export const deleteProviderEstimate = (id) =>
  axios.delete(`/api/provider-dashboard/estimates/${id}`);

export const replyToEstimate = (id, data) =>
  axios.post(`/api/provider-dashboard/estimates/${id}/reply`, data);

export const updateEstimateReply = (id, data) =>
  axios.put(`/api/provider-dashboard/estimates/${id}/reply`, data);

export const updateEstimatePreferredProductPrices = (
  id,
  preferredProductPrices
) =>
  axios.patch(
    `/api/provider-dashboard/estimates/${id}/preferred-product-prices`,
    { preferredProductPrices }
  );

// 리뷰 관리
export const fetchProviderReviews = (params) =>
  axios.get("/api/provider-dashboard/reviews", { params });

export const replyToReview = (id, data) =>
  axios.post(`/api/provider-dashboard/reviews/${id}/reply`, data);

export const updateReviewReply = (id, data) =>
  axios.put(`/api/provider-dashboard/reviews/${id}/reply`, data);

export const deleteReviewReply = (id) =>
  axios.delete(`/api/provider-dashboard/reviews/${id}/reply`);

export const deleteProviderReview = (id) =>
  axios.delete(`/api/provider-dashboard/reviews/${id}`);

// 업체 정보
export const fetchBusinessInfo = () =>
  axios.get("/api/provider-dashboard/business-info");

export const updateBusinessInfo = (data) =>
  axios.put("/api/provider-dashboard/business-info", data);

// 알림
export const fetchProviderNotifications = (params) =>
  axios.get("/api/provider-dashboard/notifications", { params });

export const fetchProviderChats = (params) =>
  axios.get("/api/provider-dashboard/chats", { params });
export const fetchProviderChatMessages = (id, params) =>
  axios.get(`/api/provider-dashboard/chats/${id}/messages`, { params });
export const sendProviderChatMessage = (id, data) =>
  axios.post(`/api/provider-dashboard/chats/${id}/messages`, data);
export const sendProviderChatImageMessage = (id, data) =>
  axios.post(`/api/provider-dashboard/chats/${id}/image-messages`, data);
export const markProviderChatRead = (id, snapshot) =>
  axios.put(`/api/provider-dashboard/chats/${id}/read`, snapshot);
export const requestProviderChatTicket = () =>
  axios.post("/api/provider-dashboard/chats/realtime-ticket");

export const markAllProviderNotificationsRead = () =>
  axios.put("/api/provider-dashboard/notifications/read-all");

// 공지사항
export const fetchProviderNotices = (params) =>
  axios.get("/api/provider-dashboard/notices", { params });

// 포인트 관리
export const fetchPendingPointRequests = () => axios.get("/api/point/pending");

export const approvePointUse = (transactionId) =>
  axios.post("/api/point/use/approve", { transactionId });

export const rejectPointUse = (transactionId) =>
  axios.post("/api/point/use/reject", { transactionId });

export const cancelPointUse = (transactionId) =>
  axios.post("/api/point/use/cancel", { transactionId });

export const fetchProviderPointHistory = (params) =>
  axios.get("/api/point/provider/history", { params });

export const fetchProviderQrInfo = () =>
  axios.get("/api/provider-dashboard/qr-info");

// 상품 관리
export const fetchProviderProducts = (params) =>
  axios.get("/api/provider-dashboard/products", { params });

export const fetchProviderProductDetail = (id) =>
  axios.get(`/api/provider-dashboard/products/${id}`);

export const createProviderProduct = (data) =>
  axios.post("/api/provider-dashboard/products", data);

export const updateProviderProduct = (id, data) =>
  axios.put(`/api/provider-dashboard/products/${id}`, data);

export const deleteProviderProduct = (id) =>
  axios.delete(`/api/provider-dashboard/products/${id}`);
